import type * as React from 'react';

/**
 * Event props for nested controls that should handle their own interaction
 * without triggering parent clickable rows.
 */
export const stopPropagationProps = {
    onClick: (event) => {
        event.stopPropagation();
    },
    onPointerDown: (event) => {
        event.stopPropagation();
    },
    onPointerUp: (event) => {
        event.stopPropagation();
    },
} satisfies Pick<React.DOMAttributes<unknown>, 'onClick' | 'onPointerDown' | 'onPointerUp'>;
